import { render, staticRenderFns } from "./ConfluenceTableRow.vue?vue&type=template&id=52ddd30a&scoped=true&"
import script from "./ConfluenceTableRow.vue?vue&type=script&lang=ts&"
export * from "./ConfluenceTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./ConfluenceTableRow.vue?vue&type=style&index=0&id=52ddd30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ddd30a",
  null
  
)

export default component.exports